export function validateUrlWithoutQueryParams(value: string): boolean {
    const urlRegex = /^(https?:\/\/)([\w.-]+)(:[0-9]+)?(\/[\w.-]*)*$/;

    if (value.includes('?') || value.includes('#')) {
        return false;
    }

    return urlRegex.test(value);
}
